import { SovosCircularProgress, SovosMenuItem, SovosSplitButton } from "mosaic-react";
import React from "react";
import styles from "./MultipleDownloadButton.module.sass";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

export const MultipleDownloadButton = (props) => {
    const { i18n, locale, download } = useGlobalValue();
    const { items, downloading, downloadableQueries, label } = props;
    const menuItems = items.reduce((acc, item, index) => {
        const { menuLabel = "" } = item || {};
        acc.push(
            <SovosMenuItem
                key={`download_query_${index}`}
                className={`${styles["action-button"]} ${downloading ? styles["has-activity"] : ""}`}
                onClick={() => download && download([downloadableQueries[index]], locale)}
            >
                {i18n`${menuLabel}`}
            </SovosMenuItem>,
        );
        return acc;
    }, []);
    return (
        <SovosSplitButton key="download" onClick={() => {}} menuItems={menuItems}>
            {downloading ? <SovosCircularProgress thickness={10} size={"1rem"} /> : label}
        </SovosSplitButton>
    );
};
